import request from '../../utils/request'
import prefix from '../prefix'
import auth from '../auth'

/***
 * 获取系统配置及字典列表
 * @param data
 * @returns {AxiosPromise}
 */
export const sysConfigSimpleList = data => {
  return request({
    url: prefix + '/sys-config/simple-list',
    method: 'post',
    data
  })
}

/***
 * 获取系统配置及字典列表
 * @param data
 * @returns {AxiosPromise}
 */
export const sysCacheRefreshList = data => {
  return request({
    url: prefix + '/sys-cache-refresh/list',
    method: 'post',
    data
  })
}

/***
 * 获取系统公告列表
 * @param data
 * @returns {AxiosPromise}
 */
export const sysNoticeList = data => {
  return request({
    url: prefix + auth + '/sys-notice/list',
    method: 'post',
    data
  })
}

/***
 * 获取系统公告分页
 * @param data
 * @returns {AxiosPromise}
 */
export const sysNoticePage = data => {
  return request({
    url: prefix + auth + '/sys-notice/page',
    method: 'post',
    data
  })
}

/** *
 * 系统支持的语言列表
 * @param data
 * @returns {AxiosPromise}
 */
export const i18nLanguageSimpleList = data => request({
  url: `${prefix}/i18n-language/simple-list`,
  method: 'post',
  data
})



// WEBPACK FOOTER //
// ./src/api/system/system.js